/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ApiKey
 */
export interface ApiKey {
    /**
     * 
     * @type {number}
     * @memberof ApiKey
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiKey
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    dateAccessed?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiKey
     */
    dateRevoked?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ApiKey
     */
    isRevoked?: boolean;
}

/**
 * Check if a given object implements the ApiKey interface.
 */
export function instanceOfApiKey(value: object): boolean {
    return true;
}

export function ApiKeyFromJSON(json: any): ApiKey {
    return ApiKeyFromJSONTyped(json, false);
}

export function ApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKey {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateAccessed': json['dateAccessed'] == null ? undefined : (new Date(json['dateAccessed'])),
        'dateRevoked': json['dateRevoked'] == null ? undefined : (new Date(json['dateRevoked'])),
        'isRevoked': json['isRevoked'] == null ? undefined : json['isRevoked'],
    };
}

export function ApiKeyToJSON(value?: ApiKey | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateAccessed': value['dateAccessed'] == null ? undefined : ((value['dateAccessed'] as any).toISOString()),
        'dateRevoked': value['dateRevoked'] == null ? undefined : ((value['dateRevoked'] as any).toISOString()),
        'isRevoked': value['isRevoked'],
    };
}

